import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  Inject,
  Input,
  PLATFORM_ID,
} from '@angular/core';
import point from '!!file-loader!../../../../shared/modules/map/assets/placemark.svg';
import emptyMap from '!!file-loader!./assets/emptyMap.png';
import { LabPassRepositoryService } from '../../services/lab-pass.repository.service';
import { isPlatformServer } from '@angular/common';
import { WriteToHelixModalService } from '@shared/components/write-to-helix-modal/services/write-to-helix-modal.service';

@Component({
  selector: 'app-where-use',
  templateUrl: './where-use.component.html',
  styleUrls: ['./where-use.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhereUseComponent {
  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    public repository: LabPassRepositoryService,
    public writeToHelixModalService: WriteToHelixModalService,
    private cdr: ChangeDetectorRef
  ) {}

  images = {
    point,
    emptyMap,
  };

  @Input() appsContainer: HTMLDivElement | undefined;

  @HostListener('window:resize')
  windowResize(): void {
    this.cdr.detectChanges();
  }

  get isSM(): boolean {
    if (isPlatformServer(this.platformId)) return false;
    return window.matchMedia('(max-width: 768px)').matches;
  }

  scrollToApps(): void {
    if (this.appsContainer)
      this.appsContainer.scrollIntoView({ behavior: 'smooth' });
  }
}
